import { StyleOfText } from "../../textStyle";


export class FreeSpinCounter
{   
    private parent:PIXI.Container;
    private numberCount:PIXI.Text;

    private mask:PIXI.Graphics;
    private tweenIn:PIXI.tween.Tween;
    private tweenOut:PIXI.tween.Tween;
    private isMobile:boolean;
  
    private labelContainer:PIXI.Container;
    // private isOn:boolean;
    private GameTextStyle:StyleOfText;
    
    constructor(parent:PIXI.Container){
        this.parent=new PIXI.Container();
        parent.addChild(this.parent);
        this.GameTextStyle= new StyleOfText();
        this.numberCount=new PIXI.Text('0',{fontFamily:this.GameTextStyle.gameFont, fontWeight:'bold' ,fontSize: 70, fill: "white" ,lineHeight : 65,align:"left"});
        this.numberCount.anchor.set(1,.5);
        
        // this.label2.anchor.set(0,.5);
        this.parent.addChild(this.numberCount);  
        this.labelContainer= new PIXI.Container()      
        this.parent.addChild(this.labelContainer);
        this.mask= new PIXI.Graphics;
        this.mask.beginFill(0xffffff);
        this.mask.drawRect(0,0,this.labelContainer.width,30);
        this.mask.endFill();
        this.mask.pivot.set(this.mask.width/2,this.mask.height/2);
        this.mask.position.set(this.mask.width/2,this.mask.height/2);
        this.parent.addChild(this.mask);

        this.tweenIn=PIXI.tweenManager.createTween(this.labelContainer);
        this.tweenIn.from({y:30}).to({y:0});
        this.tweenIn.time=800;
        this.tweenIn.easing=PIXI.tween.Easing.outBack();
        // this.tweenIn.loop=true;
        // this.tweenIn.start();
        this.isMobile=false;
        this.tweenOut=PIXI.tweenManager.createTween(this.labelContainer);
        this.tweenOut.from({y:0}).to({y:30});
        this.tweenOut.time=800;
        this.tweenOut.easing=PIXI.tween.Easing.outBack();
        // this.isOn=true;
        
    }

    // updateNumber(newValue:number)
    // {   
    //     // console.log(newValue)
    //     this.numberCount.text=String(newValue);
   
    // }

    // updateNoAnimation(newValue:number)
    // {   
    //     // console.log(newValue)
    //     this.numberCount.text=String(newValue);
    // }
    // updateNumberNoAnimation(newValue:number)
    // {
    //     this.numberCount.text=String(newValue);
    // }


    public setCount=(newValue:number):void=>
    {   
        // console.log(newValue)
        this.numberCount.text=String(newValue);
   
    }

    public setPosition=():void=>
    {
        this.parent.y=945+40;
        this.parent.x=605;   

        if(this.isMobile)
        {   
            this.parent.y=945+55;
            this.parent.x+=75;
            this.parent.scale.set(.6)
        }
        else{
            this.parent.scale.set(.75);  
        }
         
    }

    public setIsMobile=(isMobile:boolean):void=>
    {
        this.isMobile=isMobile;
    }

    public setVisibile=(bool:boolean):void=>
    {   
        var i = bool ? 1 : 0;
        this.parent.alpha=i;
    }
}

